import { render } from "./accentedTerm.vue?vue&type=template&id=589fd8d6&scoped=true"
const script = {}

import "./accentedTerm.vue?vue&type=style&index=0&id=589fd8d6&scoped=true&lang=css"

import exportComponent from "E:\\dyy\\备份\\百廿官网\\bnkjgw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589fd8d6"]])

export default __exports__